import React from 'react'

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles'
import OriginalBadge, { BadgeProps as OriginalBadgeProps } from '@material-ui/core/Badge'

interface Props extends OriginalBadgeProps {
}

const styles = createStyles({
  badge: {
    width: 14,
    height: 14,
    top: -2,
    right: -4,
    fontSize: 7,
    fontWeight: 600,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const Badge: React.SFC<InjectedProps> = ({ classes: { badge }, ...props }) => {
  return <OriginalBadge {...props} classes={{ badge }} />
}

export default withStyles(styles)(Badge)
